import { headers, parseJSON } from '../../apiUtils';
import { downloadFile, getUtcTime } from '../../utils';

export function fetchQaSurveyforms() {
    const path = `/api/QaDashboard/surveyforms`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentTeamQaScore(agentId, surveyFormId) {//from, to dates
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);

    const path = `/api/QaDashboard/agent-team-qascore?agentId=${agentId}&surveyFormId=${surveyFormId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentCompletedAuditsDetails(agentId, surveyFormId) {//from, to dates
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);

    const path = `/api/QaDashboard/agent-completed-audits-details?agentId=${agentId}&surveyFormId=${surveyFormId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchQaSurveyCountForAllSurveyForms(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);

    const path = `/api/QaDashboard/qa-survey-count-for-all-surveyforms?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchQaSurveyFormQuestions(surveyFormId) {
    const path = `/api/QaDashboard/surveyform-questions?surveyFormId=${surveyFormId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAllInteractions(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/QaDashboard/all-interactions-to-qa?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchCompletedAudits(fromDate, toDate, surveyFormId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/QaDashboard/completed-audits?fromDate=${fromDate}&toDate=${toDate}&surveyFormId=${surveyFormId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchProgressOverTimeStats(timePeriodicity, fromDate, toDate, surveyFormId, reasonForContactId, channelId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/QaDashboard/progress-over-time-stats?selectedTimePeriodicity=${timePeriodicity}&fromDate=${fromDate}&toDate=${toDate}&surveyFormId=${surveyFormId}`;
    if (reasonForContactId) {
        path += `&reasonForContactId=${reasonForContactId}`;
    }
    if (channelId) {
        path += `&channelId=${channelId}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchResponseBreakdown(surveyTypeId, fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/QaDashboard/response-breakdown?fromDate=${fromDate}&toDate=${toDate}&surveyTypeId=${surveyTypeId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAuditsReport(surveyFormId, fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/QaDashboard/report-audits?surveyFormId=${surveyFormId}&fromDate=${fromDate}&toDate=${toDate}`;

    return downloadFile(path);
}

export function _submitQaSurvey(surveyResult) {
    const url = `/api/QaDashboard/submit`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(surveyResult),
        method: 'POST'
    });
}

export function _postCoachingSession(coachingSession) {
    const url = `/api/QaDashboard/agent-coaching-session`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(coachingSession),
        method: 'POST'
    });
}

export function _deleteAudit(surveyId) {
    const url = `/api/QaDashboard/delete-audit`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(surveyId),
        method: 'POST'
    });
}
